export { validators as default } from '@wix/santa-editor-utils';
